import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import route from './modules/router'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    route
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      render(state){
        return {...state}
      }
    })
  ]
})